import PropTypes from 'prop-types';
import React, { useCallback, useMemo } from 'react';
import { useHistory, useLocation, useParams } from 'react-router-dom';

import {
  ROUTE_HOME,
  ROUTE_SCANBAT,
  ROUTE_SCANBAT_LOGIN,
  ROUTE_STANDALONE_CART,
  ROUTE_STANDALONE_LOGIN,
  ROUTE_SUPPLIER,
} from '@/common/constants';
import { AuthContext } from '@/common/contexts/AuthContext';

const SubmitHandler = ({ errors, login, component: Login, paramIsOpen }) => {
  const history = useHistory();
  const location = useLocation();
  const params = useParams();

  const from = useMemo(() => {
    // Redirect to origin route if declared
    if (location.state?.from) {
      return location.state.from;
    }

    if (location.pathname === ROUTE_SCANBAT_LOGIN) {
      return { pathname: ROUTE_SCANBAT };
    }

    // Redirect to standalone if login standalone is current route
    if (location.pathname === ROUTE_STANDALONE_LOGIN) {
      return { pathname: ROUTE_STANDALONE_CART };
    }

    if (
      location.pathname.startsWith(ROUTE_SUPPLIER) &&
      params.slug !== undefined
    ) {
      return `${ROUTE_SUPPLIER}/${params.slug}`;
    }

    // Redirect to home by default
    return { pathname: ROUTE_HOME };
  }, [location, params]);

  const handleSubmit = useCallback(
    (credentials, onSuccess) =>
      login(credentials, onSuccess).then((response) => {
        history.replace(from);

        return response;
      }),
    [from, history, login],
  );

  return (
    <Login errors={errors} onSubmit={handleSubmit} paramIsOpen={paramIsOpen} />
  );
};

SubmitHandler.propTypes = {
  errors: PropTypes.arrayOf(PropTypes.string).isRequired,
  login: PropTypes.func.isRequired,
  component: PropTypes.func.isRequired,
  paramIsOpen: PropTypes.bool.isRequired,
};

export default (Login) => {
  const LoginHoc = ({ paramIsOpen }) => (
    <AuthContext.Consumer>
      {({ authErrors: errors, login }) => (
        <SubmitHandler
          errors={errors}
          login={login}
          component={Login}
          paramIsOpen={paramIsOpen}
        />
      )}
    </AuthContext.Consumer>
  );

  LoginHoc.defaultProps = {
    paramIsOpen: false,
  };

  LoginHoc.propTypes = {
    paramIsOpen: PropTypes.bool,
  };

  return LoginHoc;
};
